module.exports = __webpack_public_path__ + "img/art-inhalt.2c9e7799.png";